import * as React from "react";
import { graphql } from "gatsby";
import HomepageBrands from "./homepageBrands";
import CompactBrands from "./compactBrands";

export const fragment = graphql`
  fragment BrandsContent on ContentfulPageSectionBrands {
    name
    title
    compact
    brands {
      contentful_id
      slug
      name
      largeLogo {
        description
        gatsbyImageData(layout: CONSTRAINED, width: 450, height: 450)
      }
    }
    internal {
      type
    }
  }
`;

const Brands = ({ data, hrefLang }) => {
  const { compact: isCompact } = data;
  if (isCompact) {
    return <CompactBrands data={data} />;
  }
  return <HomepageBrands data={data} hrefLang={hrefLang} />;
};

export const brandsName = "ContentfulPageSectionBrands";

export default Brands;
